/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FindAllStateTownsResponse } from './FindAllStateTownsResponse';
import {
    FindAllStateTownsResponseFromJSON,
    FindAllStateTownsResponseFromJSONTyped,
    FindAllStateTownsResponseToJSON,
    FindAllStateTownsResponseToJSONTyped,
} from './FindAllStateTownsResponse';

/**
 * 
 * @export
 * @interface FindAllStateTowns200Response
 */
export interface FindAllStateTowns200Response {
    /**
     * 
     */
    data?: FindAllStateTownsResponse;
}

/**
 * Check if a given object implements the FindAllStateTowns200Response interface.
 */
export function instanceOfFindAllStateTowns200Response(value: object): value is FindAllStateTowns200Response {
    return true;
}

export function FindAllStateTowns200ResponseFromJSON(json: any): FindAllStateTowns200Response {
    return FindAllStateTowns200ResponseFromJSONTyped(json, false);
}

export function FindAllStateTowns200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllStateTowns200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : FindAllStateTownsResponseFromJSON(json['data']),
    };
}

export function FindAllStateTowns200ResponseToJSON(json: any): FindAllStateTowns200Response {
    return FindAllStateTowns200ResponseToJSONTyped(json, false);
}

export function FindAllStateTowns200ResponseToJSONTyped(value?: FindAllStateTowns200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': FindAllStateTownsResponseToJSON(value['data']),
    };
}

